const options = {
  5: "bg-red-200/5",
  10: "bg-red-200/10",
  25: "bg-red-200/25",
  50: "bg-red-200/50",
  75: "bg-red-200/75",
  90: "bg-red-200/90",
  100: "bg-red-200",
};

const from = {
  5: "from-red-200/5",
  10: "from-red-200/10",
  25: "from-red-200/25",
  50: "from-red-200/50",
  75: "from-red-200/75",
  90: "from-red-200/90",
  100: "from-red-200",
};

export default function getBackgroundRed200(opacity, isFrom) {
  return (isFrom ? from : options)[opacity || 100];
}
